import {
	Avatar,
	Card,
	Divider,
	message,
	Select,
	Table,
	Tag,
	Tooltip,
} from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import TableHeaderSection from '../../component/TableHeaderSection';
import baseuri from '../../methods/baseuri';
import {
	Country,
	genderEnum,
	statusColor,
} from '../../methods/utils/request-helpers';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { getUserProfileById } from '../../methods/redux/reducers/user-profile';
import { MyEmptyTable } from '../../robots/email-robot/EmailRobot';
import { MyTableCard } from '../users-list/UsersByCountry';
import { MyTable } from '../users-list/UsersList';
import ImageComponent from './ImageComponent';
import NextKyc from './NextKyc';
import RejectKYC from './RejectKYC';
import { FakeRef, SearchSection, TableProfile } from './UsersKYC';

const MyCard = styled(Card)`
	border-radius: 10px;

	.profile-badge-icon {
		display: flex;
		justify-content: center;
		position: relative;
		display: inline-block;
		padding: 5px;
		font-size: 12px;
		margin-right: 5px;
		font-weight: 600;

		& .icon {
			position: absolute;
			font-size: 12px;
			font-weight: bold;
			color: white;
			top: -5px;
			right: -5px;
			background: var(--green-color);
			height: 14px;
			width: 14px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 50%;
		}
	}

	.sumsub-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 10px;
	}

	.verification-item {
		margin-bottom: 12px;
		border-bottom: 1px solid #d4caca;

		& h3 {
			margin-bottom: 4px;
		}
	}
`;
const Level1Section = styled.div`
	min-width: 250px;

	& .sus {
		color: red;
	}
`;

const MainColumn = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	/* justify-content: center; */
	/* align-items: center; */
	gap: 0.5em;
`;

const Levels = styled.div`
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	gap: 1em;
	min-width: 200px;
`;

const SusLink = styled.div`
	display: flex;
	gap: 2em;
	min-width: 220px;
	& .sus {
		color: #d93025;
		font-weight: 500;
		cursor: pointer;
	}
`;

export const VerificationStatusGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 24px;
	margin-top: 16px;
	
	.v-column {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.status-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px;
		background: #f9fafb;
		border-radius: 6px;
		font-size: 14px;
		color: #374151;

		.label {
			font-weight: 500;
		}

		.value {
			font-weight: 600;
			color: #111827;
		}
	}
`;

const LegacyGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1.5fr 1fr;
	gap: 40px;
	color: #333;
	font-size: 14px;
	padding: 8px 0;

	p {
		margin-bottom: 8px;
		color: #555;
	}

	strong {
		color: #111;
		font-weight: 600;
	}

	.legacy-label {
		text-transform: uppercase;
		color: #4b5563;
		margin-right: 4px;
	}
`;

const WarningBlock = styled.div`
	margin-top: 48px;
	max-width: 320px;

	.warning-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 12px;
		color: #4b5563;
		
		&.error {
			color: #d93025;
			.legacy-val, strong { color: #d93025; }
		}

		.legacy-val {
			font-weight: 700;
			margin-left: auto;
			margin-right: 16px;
		}
	}
	.view-btn {
		background: #fdf2f2;
		color: #333;
		border: 1px solid #f9cdcd;
		padding: 2px 12px;
		border-radius: 4px;
		font-size: 12px;
		cursor: pointer;
		text-decoration: none;
		transition: all 0.2s;

		&:hover {
			background: #f9cdcd;
		}
	}
`;

const IDPhotoBlock = styled.div`
	display: flex;
	gap: 16px;
	margin-top: 16px;
	margin-bottom: 24px;

	.photo-box {
		width: 100px;
		
		.title {
			font-weight: 700;
			font-size: 13px;
			margin-bottom: 6px;
			color: #111;
		}

		.img-container {
			width: 100px;
			height: 100px;
			border: 2px solid #aaa;
			border-radius: 4px;
			overflow: hidden;
			display: flex;
			align-items: center;
			justify-content: center;
			background: #f3f4f6;
		}
	}
`;

const LegacyAvatar = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background: #5c6ac4;
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-size: 18px;
	margin-bottom: 12px;
`;

const KYCDataCard = {
	display: 'flex',
	gap: '1em',
	width: '100%',
};

export const KycContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const SectionCard = styled.div`
	background: white;
	border-radius: 8px;
	border: 1px solid #e8e8e8;
	padding: 24px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

	h2 {
		margin-top: 0;
		margin-bottom: 16px;
		font-size: 18px;
		font-weight: 600;
		color: #1f2937;
		display: flex;
		align-items: center;
	}
`;

export const HeaderBadge = styled.span<{ status?: 'Approved' | 'Pending' | 'Rejected' | 'valid' | 'invalid' }>`
	display: inline-flex;
	align-items: center;
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 500;
	text-transform: capitalize;
	background: ${(props) => {
		if (props.status === 'Approved' || props.status === 'valid') return '#e6f4ea';
		if (props.status === 'Rejected' || props.status === 'invalid') return '#fce8e6';
		return '#f3f4f6';
	}};
	color: ${(props) => {
		if (props.status === 'Approved' || props.status === 'valid') return '#1e8e3e';
		if (props.status === 'Rejected' || props.status === 'invalid') return '#d93025';
		return '#374151';
	}};
	margin-left: 12px;
	vertical-align: middle;
`;

export const ImageGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	margin-bottom: 24px;
`;

export const ImageCard = styled.div`
	border: 1px solid #e8e8e8;
	border-radius: 8px;
	padding: 16px;
	background: white;
	width: 280px;

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 12px;
		font-size: 14px;
		color: #6b7280;

		a {
			color: #1890ff;
			font-weight: 500;
			text-decoration: none;
		}
	}

	.image-wrapper {
		width: 100%;
		height: 200px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #f9fafb;
		border-radius: 4px;
		overflow: hidden;

		img {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
		}
	}

	.footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 12px;
		font-size: 13px;
		color: #6b7280;

		.date {
			color: #111827;
			font-weight: 500;
		}
	}
`;

export const DataBlock = styled.div`
	background: #f9fafb;
	border-radius: 8px;
	padding: 20px;
	
	h3 {
		margin-top: 0;
		margin-bottom: 16px;
		font-size: 16px;
		font-weight: 600;
		color: #111827;
	}

	.grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 20px;
	}

	.field {
		.label {
			font-size: 13px;
			color: #6b7280;
			margin-bottom: 4px;
		}
		.value {
			font-size: 15px;
			color: #111827;
			font-weight: 500;
		}
	}
`;

export const SummaryBlock = styled.div`
	.header-title {
		font-size: 24px;
		font-weight: 700;
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}
	
	.meta-info {
		color: #6b7280;
		font-size: 14px;
		margin-bottom: 24px;
		line-height: 1.6;

		span.label {
			color: #9ca3af;
		}
	}

	h3 {
		font-size: 18px;
		font-weight: 600;
		margin-top: 24px;
		margin-bottom: 16px;
		color: #111827;
	}

	.verification-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin-bottom: 24px;

		.v-item {
			font-size: 15px;
			font-weight: 600;
			color: #111827;
			display: flex;
			align-items: center;
		}
	}

	.data-list {
		display: flex;
		flex-direction: column;
		gap: 8px;
		font-size: 15px;
		color: #111827;
		margin-bottom: 24px;

		.label {
			color: #6b7280;
		}
	}
`;

const ManageKYC = () => {
	const dispatch = useAppDispatch();
	const { id } = useParams<{ id: string }>();
	const [refresh, setRefresh] = useState(0);
	const [data, setData] = useState({} as any);
	const [kycHistory, setKycHistory] = useState({} as any);
	const [selectedGateway, setSelectedGateway] = useState(
		'https://cf-ipfs.com/ipfs/'
	);
	console.info(selectedGateway);
	const { user } = useAppSelector((store) => store.userProfile);

	const gateWays = [
		{ name: 'https://cf-ipfs.com/ipfs/', value: 'https://cf-ipfs.com/ipfs/' },
		{ name: 'https://ipfs.io/ipfs/', value: 'https://ipfs.io/ipfs/' },
		{
			name: 'https://cloudflare-ipfs.com/ipfs/',
			value: 'https://cloudflare-ipfs.com/ipfs/',
		},
		{
			name: 'https://gateway.ipfs.io/ipfs/',
			value: 'https://gateway.ipfs.io/ipfs/',
		},
		{
			name: 'https://gateway.pinata.cloud/ipfs/',
			value: 'https://gateway.pinata.cloud/ipfs/',
		},
	];

	const approve = async (userId: string, url: string) => {
		try {
			const res: any = await baseuri.post(url, {
				id: userId,
				kycStatus: 'approved',
			});

			if (res.status === 200) {
				message.success(`Approved successfully `);
				const k = data.itemsList.filter(
					(n: any) => n?.getUserKyc?.userId?._id !== userId
				);
				setData({
					...data,
					itemsList: k,
				});
				setRefresh(Math.random());
			} else {
				message.error(res?.message);
			}
		} catch (e: any) {
			message.error('something went wrong');
		}
	};

	const getKycHistory = async () => {
		setKycHistory({ loading: true });
		try {
			const res: any = await baseuri.get('admin/kyc/rejected-kyc-records', {
				params: {
					userId: id,
				},
			});

			if (res.status === 200) {
				setKycHistory({ ...kycHistory, ...res.data.data, loading: false });
			} else {
				setKycHistory({ loading: false });
			}
		} catch (error) {
			setKycHistory({ loading: false });
		}
	};

	const getSingleKYC = async () => {
		setData({ loading: true });
		try {
			const res: any = await baseuri.get('admin/kyc/single-kyc-details', {
				params: {
					id,
				},
			});

			if (res.status === 200) {
				setData({
					...data,
					itemsList: [res.data.data],
					loading: false,
					...res.data.data,
				});
			} else {
				setData({ loading: false });
			}
		} catch (error) {
			setData({ loading: false });
		}
	};

	const hiddenNumbers = (kyc: string) => {
		const firstTwo = kyc.slice(0, 2);
		const lastTwo = kyc.slice(-2);
		const zeros = '0'.repeat(Math.max(0, kyc.length - 4));
		return firstTwo + zeros + lastTwo;
	};

	useEffect(() => {
		getKycHistory();
		getSingleKYC();
		dispatch(getUserProfileById(id));
	}, [refresh, id]);

	// Removed legacy columns array as we're switching to Grid/Card layout
	const columns2 = [
		{
			title: 'Level 1',
			key: 9024352,
			render: (text: any) => (
				<Level1Section>
					<p>
						FULL NAME:{' '}
						<strong>
							{`${text?.lastName}  ${text?.firstName}  ${text?.middleName}` ||
								'N/A'}
						</strong>
					</p>
					<p>
						PHONE NUMBER: <strong>+{text?.phoneNumber || 'N/A'}</strong>
					</p>
					<p>
						DATE OF BIRTH: <strong>{text?.dateOfBirth || 'N/A'}</strong>
					</p>
					<p>
						Age:{' '}
						<strong>
							{Math.floor(
								moment().diff(moment(text?.dateOfBirth, 'DD/MM/YYYY'), 'years')
							) <= 18 ? (
								<FakeRef>
									<Tooltip title="User is too young" color="#a10909">
										{moment().diff(
											moment(text?.dateOfBirth, 'DD/MM/YYYY'),
											'years'
										)}
									</Tooltip>
								</FakeRef>
							) : (
								moment().diff(moment(text?.dateOfBirth, 'DD/MM/YYYY'), 'years')
							)}
						</strong>
					</p>
					<p>
						Gender: <strong>{genderEnum(text?.gender) || 'N/A'}</strong>
					</p>
					<p>
						ADDRESS:{' '}
						<strong
							className={`${text?.residentAddress.length < 15 ? 'sus' : ''}`}
						>
							{text?.residentAddress || 'N/A'}
						</strong>
					</p>
					<p>
						COUNTRY:{' '}
						<strong>{Country(text?.countryCode.toUpperCase()) || 'N/A'}</strong>
					</p>
				</Level1Section>
			),
		},
		{
			title: 'Level 2',
			key: 309536,
			render: (text: any) => (
				<MainColumn>
					<p>
						Rejected by: <strong>{text?.rejectedBy?.email || 'N/A'}</strong>
					</p>
					<Levels>
						<p>
							<strong>ID Card</strong>
							<ImageComponent
								secret={text.idcardEncryptKey}
								url={`${text.idcardUrl}`}
								createdAt={text?.createdAt}
							/>
						</p>
						<p>
							<strong>Live Photo</strong>
							<ImageComponent
								secret={text.selfieEncryptKey}
								url={`${text.selfieUrl}`}
								createdAt={text?.createdAt}
							/>
						</p>
					</Levels>
					<p>
						ID Type: <strong> {text?.idcardType || 'N/A'}</strong>
					</p>
					<p>
						ID NUMBER: <strong> {text?.idcardNumber || 'N/A'}</strong>
					</p>
					{/* <Divider /> */}

					{/* <Levels>
						{text?.userId?.kycLevelTwoStatus === 'submitted' && (
							<Tag
								style={{ cursor: 'pointer' }}
								color="blue"
								onClick={() =>
									approve(text?.userId?._id, 'admin/kyc/update-levelTwo-kyc')
								}
							>
								Approve
							</Tag>
						)}
						{text?.userId?.kycLevelTwoStatus === 'submitted' ||
						text?.userId?.kycLevelTwoStatus === 'approved' ? (
							<RejectKYC
								text="Reject"
								url="admin/kyc/update-levelTwo-kyc"
								userId={text?.userId}
								data={data}
								setData={setData}
								setRefresh={setRefresh}
							/>
						) : (
							''
						)}
					</Levels> */}
				</MainColumn>
			),
		},
		{
			title: 'Rejection Message',
			key: 309536,
			render: (text: any) => (
				<MainColumn>
					<p>
						Rejection Time:
						<strong>{moment(text?.rejectionTime).format('lll')}</strong>
					</p>
					<p>
						<strong>Rejection Reason</strong>
						<div>{text?.levelTwoRejectionReason}</div>
					</p>
					<p>
						<strong>Rejection Message</strong>
						<div>{text?.levelTwoRejectionMessage}</div>
					</p>
				</MainColumn>
			),
		},
	];

	return (
		<div>
			<SearchSection>
				<div>
					Select gateway :{' '}
					<Select
						// mode="multiple"
						placeholder="Select GateWay"
						// value={newsletter?.maillist}
						onChange={(e: any) => setSelectedGateway(e)}
						defaultValue="https://cf-ipfs.com/ipfs/"
						// style={{ width: '100%' }}
					>
						{gateWays?.map((gateway: any) => (
							<Select.Option key={gateway.name} value={gateway.value}>
								{gateway.name}
							</Select.Option>
						))}
					</Select>
				</div>
				<NextKyc text="Next KYC" />
			</SearchSection>
			<br />
			<KycContainer style={{ marginTop: '16px' }}>
				{data?.itemsList?.map((text: any) => (
					<SectionCard key={text?.getUserKyc?.userId?._id}>
						<SummaryBlock>
							<div className="header-title" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
								{text?.getUserKyc?.firstName || text?.getUserKyc?.userId?.firstName} {text?.getUserKyc?.lastName || text?.getUserKyc?.userId?.lastName}
								<HeaderBadge status={text?.getUserKyc?.userId?.kycLevelTwoStatus === 'approved' ? 'Approved' : (text?.getUserKyc?.userId?.kycLevelTwoStatus === 'rejected' ? 'Rejected' : 'Pending')}>
									{text?.getUserKyc?.userId?.kycLevelTwoStatus || 'N/A'}
								</HeaderBadge>

								{text?.getUserKyc?.userId?.profileUrl ? (
									<Avatar src={text?.getUserKyc?.userId?.profileUrl} size={32} />
								) : (
									<Avatar className="avatar" size={32} style={{ backgroundColor: '#1890ff' }}>
										{text?.getUserKyc?.userId?.username?.charAt(0)?.toUpperCase()}
									</Avatar>
								)}
							</div>
							
							<div className="meta-info">
								<div><span className="label">Username: </span>
									<Link to={`/user-profile/${text?.getUserKyc?.userId?._id}`} target="_blank" rel="noopener noreferrer">
										@{text?.getUserKyc?.userId?.username}
									</Link>
								</div>
								<div><span className="label">Email: </span>{text?.getUserKyc?.userId?.email}</div>
								<div><span className="label">Referred by: </span>{text?.getUserKyc?.userId?.refereeName || '---'}</div>
								<div><span className="label">Date Created: </span>{moment(text?.getUserKyc?.createdAt).format('YYYY-MM-DD, HH:mm:ss')}</div>
								<div><span className="label">Date Updated: </span>{moment(text?.getUserKyc?.updatedAt).format('YYYY-MM-DD, HH:mm:ss')}</div>
								{text?.getUserKyc?.userId?.KycLevelTwoApprovedBy?.email && (
									<div><span className="label">Last Updated by: </span>{text?.getUserKyc?.userId?.KycLevelTwoApprovedBy?.email}</div>
								)}
								{text?.getUserKyc?.custodialAdminId && (
									<div><span className="label" style={{ color: '#1890ff' }}>Updated by Admin</span></div>
								)}
							</div>

							<h3>Verifications & Risks</h3>
							<div className="verifications-grid">
								<div className="v-item">
									BlackListed User/Device - <HeaderBadge status={data?.blacklistRecord?.blacklisted ? 'Rejected' : 'Approved'}>{data?.blacklistRecord?.blacklisted ? 'Yes' : 'No'}</HeaderBadge>
								</div>
								<div className="v-item" style={{ gap: '8px' }}>
									KYCs with same Phone Number - <HeaderBadge status={Number(data?.duplicatephoneNumber) > 1 ? 'Rejected' : 'Pending'}>{data?.duplicatephoneNumber || 0}</HeaderBadge>
									{Number(data?.duplicatephoneNumber) > 1 && (
										<Link to={`/kyc-suspects?phoneNumber=${text?.getUserKyc?.phoneNumber}`} style={{ fontSize: '12px', background: '#fee2e2', color: '#d93025', padding: '2px 8px', borderRadius: '4px', border: '1px solid #fca5a5', marginLeft: '8px' }}>View</Link>
									)}
								</div>
								<div className="v-item" style={{ gap: '8px' }}>
									KYCs with same ID Number - <HeaderBadge status={Number(data?.duplicateIdcardNumber) > 1 ? 'Rejected' : 'Pending'}>{data?.duplicateIdcardNumber || 0}</HeaderBadge>
									{Number(data?.duplicateIdcardNumber) > 1 && (
										<Link to={`/kyc-suspects?idcardNumber=${text?.getUserKyc?.idcardNumber}`} style={{ fontSize: '12px', background: '#fee2e2', color: '#d93025', padding: '2px 8px', borderRadius: '4px', border: '1px solid #fca5a5', marginLeft: '8px' }}>View</Link>
									)}
								</div>
								<div className="v-item" style={{ gap: '8px' }}>
									Users with same device - <HeaderBadge status={Number(data?.userRegisteredWithDevice) > 1 ? 'Rejected' : 'Pending'}>{data?.userRegisteredWithDevice || 0}</HeaderBadge>
									{Number(data?.userRegisteredWithDevice) > 1 && (
										<Link to={`/kyc-suspects?deviceId=${text?.getUserKyc?.deviceId || text?.getUserKyc?.userId?.deviceSerialNumber || 'N/A'}`} style={{ fontSize: '12px', background: '#fee2e2', color: '#d93025', padding: '2px 8px', borderRadius: '4px', border: '1px solid #fca5a5', marginLeft: '8px' }}>View</Link>
									)}
								</div>
							</div>

							<h3>Personal data</h3>
							<div className="data-list">
								<div style={{fontWeight: 600, fontSize: '16px', marginBottom: '8px'}}>General info</div>
								<div><span className="label">First names: </span>{text?.getUserKyc?.firstName || '--'}</div>
								<div><span className="label">Middle names: </span>{text?.getUserKyc?.middleName || '--'}</div>
								<div><span className="label">Last name: </span>{text?.getUserKyc?.lastName || '--'}</div>
								<div><span className="label">Phone number: </span>+{text?.getUserKyc?.phoneNumber || '--'}</div>
								<div><span className="label">Date of birth: </span>{text?.getUserKyc?.dateOfBirth || '--'}</div>
								
								<div><span className="label">Age: </span>
									{Math.floor(moment().diff(moment(text?.getUserKyc?.dateOfBirth, 'DD/MM/YYYY'), 'years')) <= 18 ? (
										<Tooltip title="User is too young" color="#a10909">
											<span style={{ color: '#d93025', fontWeight: 600 }}>{moment().diff(moment(text?.getUserKyc?.dateOfBirth, 'DD/MM/YYYY'), 'years')}</span>
										</Tooltip>
									) : (
										moment().diff(moment(text?.getUserKyc?.dateOfBirth, 'DD/MM/YYYY'), 'years')
									)}
								</div>
								
								<div><span className="label">Gender: </span>{genderEnum(text?.getUserKyc?.gender) || '--'}</div>
								<div><span className="label">Address: </span>
									<span style={text?.getUserKyc?.residentAddress?.length < 15 ? { color: '#d93025', fontWeight: 600 } : {}}>
										{text?.getUserKyc?.residentAddress || '--'}
									</span>
								</div>
								<div><span className="label">Country: </span>{Country(text?.getUserKyc?.countryCode?.toUpperCase()) || '--'}</div>
								<div><span className="label">Device Id/Serial No.: </span>{text?.getUserKyc?.deviceId || text?.getUserKyc?.userId?.deviceSerialNumber || '--'}</div>
							</div>

							<div className="data-list" style={{ marginTop: '24px' }}>
								<div style={{fontWeight: 600, fontSize: '16px', marginBottom: '8px'}}>Identity Document</div>
								<div><span className="label">ID Type: </span>{text?.getUserKyc?.idcardType || '--'}</div>
								<div><span className="label">ID Number: </span>{text?.getUserKyc?.idcardNumber || '--'}</div>
							</div>
						</SummaryBlock>

						<div style={{ padding: '0 24px 24px 24px' }}>
							<h3 style={{ fontSize: '15px', fontWeight: 600, marginBottom: '16px', borderTop: '1px solid #eaeaea', paddingTop: '24px' }}>Document Images</h3>
							<ImageGrid>
								{text?.getUserKyc?.idcardUrl && (
									<ImageCard>
										<div className="img-wrapper">
											<ImageComponent
												createdAt={text?.getUserKyc?.createdAt}
												secret={text?.getUserKyc?.idcardEncryptKey}
												url={`${text?.getUserKyc?.idcardUrl}`}
											/>
										</div>
										<div className="card-content">
											<div className="card-title">ID Card</div>
											<div className="card-meta">Uploaded: {moment(text?.getUserKyc?.createdAt).format('YYYY-MM-DD')}</div>
											<a href={text?.getUserKyc?.idcardUrl} target="_blank" rel="noopener noreferrer" className="card-link">View Original</a>
										</div>
									</ImageCard>
								)}
								{text?.getUserKyc?.selfieUrl && (
									<ImageCard>
										<div className="img-wrapper">
											<ImageComponent
												createdAt={text?.getUserKyc?.createdAt}
												secret={text?.getUserKyc?.selfieEncryptKey}
												url={`${text?.getUserKyc?.selfieUrl}`}
											/>
										</div>
										<div className="card-content">
											<div className="card-title">Live Photo</div>
											<div className="card-meta">Uploaded: {moment(text?.getUserKyc?.createdAt).format('YYYY-MM-DD')}</div>
											<a href={text?.getUserKyc?.selfieUrl} target="_blank" rel="noopener noreferrer" className="card-link">View Original</a>
										</div>
									</ImageCard>
								)}
							</ImageGrid>

							<div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
								{(text?.getUserKyc?.userId?.kycLevelTwoStatus === 'submitted' || text?.getUserKyc?.userId?.kycLevelTwoStatus === 'rejected') && (
									<Tag
										style={{ cursor: 'pointer', padding: '6px 16px', fontSize: '14px', margin: 0, background: '#10b981', color: '#fff', border: 'none', borderRadius: '4px', display: 'flex', alignItems: 'center' }}
										onClick={() => approve(text?.getUserKyc?.userId?._id, 'admin/kyc/level-two-kyc')}
									>
										Approve
									</Tag>
								)}
								{(text?.getUserKyc?.userId?.kycLevelTwoStatus === 'submitted' || text?.getUserKyc?.userId?.kycLevelTwoStatus === 'approved') && (
									<RejectKYC
										text="Reject"
										url="admin/kyc/level-two-kyc"
										userId={text?.getUserKyc?.userId}
										data={data}
										setData={setData}
										setRefresh={setRefresh}
									/>
								)}
							</div>
						</div>
					</SectionCard>
				))}
			</KycContainer>

			<MyCard style={{ marginTop: '8px' }}>
				<h2 style={{ marginBottom: '8px' }}>
					<strong>Kyc BVN Data</strong>
				</h2>
				{data?.getUserKyc?.userId?.kycBVNData ? (
					<div style={KYCDataCard}>
						<div>
							<p>
								<strong>ID Card</strong>
							</p>
							<ImageComponent
								createdAt=""
								secret=""
								url={`${data?.getUserKyc?.userId?.kycBVNData?.photo}`}
							/>
						</div>
						<div>
							<p>
								FirstName:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.firstName
										? data?.getUserKyc?.userId?.kycBVNData?.firstName
										: '--'}
								</strong>
							</p>
							<p>
								Middle Name:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.middleName
										? data?.getUserKyc?.userId?.kycBVNData?.middleName
										: '--'}
								</strong>
							</p>
							<p>
								Last Name:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.lastName
										? data?.getUserKyc?.userId?.kycBVNData?.lastName
										: '--'}
								</strong>
							</p>
							<p>
								Gender:{' '}
								<strong>
									{' '}
									{data?.getUserKyc?.userId?.kycBVNData?.gender
										? data?.getUserKyc?.userId?.kycBVNData?.gender
										: '--'}
								</strong>
							</p>
							<p>
								Birthday:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.birthday
										? data?.getUserKyc?.userId?.kycBVNData?.birthday
										: '--'}
								</strong>
							</p>
							<p>
								BVN:
								<strong>
									{' '}
									{data?.getUserKyc?.userId?.kycBVNData?.bvn
										? hiddenNumbers(data?.getUserKyc?.userId?.kycBVNData?.bvn)
										: '--'}
								</strong>
								{data?.getUserKyc?.userId?.kycBVN && (
									<div className="profile-badge-icon">
										<span className="material-symbols-outlined icon">
											check_small
										</span>
									</div>
								)}
							</p>
							<p>
								Phone Number:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.phoneNumber
										? data?.getUserKyc?.userId?.kycBVNData?.phoneNumber
										: '--'}
								</strong>
							</p>
							<p>
								Phone Number2:{' '}
								<strong>
									{data?.getUserKyc?.userId?.kycBVNData?.phoneNumber2
										? data?.getUserKyc?.userId?.kycBVNData?.phoneNumber2
										: '--'}
								</strong>
							</p>
						</div>
					</div>
				) : (
					<div style={{ textAlign: 'center' }}>BVN data not available</div>
				)}
			</MyCard>

			{/* Sumsub data */}
			<MyCard style={{ marginTop: '8px' }}>
				<h2 style={{ marginBottom: '8px' }}>
					<strong>SUM SUB Data</strong>
				</h2>
				{data?.getUserKyc?.sumsubData?.country ? (
					<div>
						<p>
							Country:{' '}
							<strong>
								{data?.getUserKyc?.sumsubData?.country
									? data?.getUserKyc?.sumsubData?.country
									: '--'}
							</strong>
						</p>
						<p>
							Dob:{' '}
							<strong>
								{data?.getUserKyc?.sumsubData?.dob
									? data?.getUserKyc?.sumsubData?.dob
									: '--'}
							</strong>
						</p>
						<p>
							First Name:{' '}
							<strong>
								{data?.getUserKyc?.sumsubData?.firstName
									? data?.getUserKyc?.sumsubData?.firstName
									: '--'}
							</strong>
						</p>
						<p>
							Last Name:{' '}
							<strong>
								{' '}
								{data?.getUserKyc?.sumsubData?.lastName
									? data?.getUserKyc?.sumsubData?.lastName
									: '--'}
							</strong>
						</p>

						<p style={{ marginTop: '12px', marginBottom: '3px' }}>
							<strong>ID Docs</strong>
						</p>
						<div className="sumsub-grid">
							{data?.getUserKyc?.sumsubData?.idDocs?.length > 0 &&
								data?.getUserKyc?.sumsubData?.idDocs?.map((idDoc: any) => (
									<div
										key={idDoc?.number}
										style={{ border: '1px solid #d4caca', padding: '4px 13px' }}
									>
										<p>
											Country:{' '}
											<strong>{idDoc?.country ? idDoc?.country : '--'}</strong>
										</p>
										<p>
											Dob: <strong>{idDoc?.dob ? idDoc?.dob : '--'}</strong>
										</p>
										<p>
											First Name:{' '}
											<strong>
												{idDoc?.firstName ? idDoc?.firstName : '--'}
											</strong>
										</p>
										<p>
											First Name En:{' '}
											<strong>
												{idDoc?.firstNameEn ? idDoc?.firstNameEn : '--'}
											</strong>
										</p>
										<p>
											Last Name:{' '}
											<strong>
												{idDoc?.lastName ? idDoc?.lastName : '--'}
											</strong>
										</p>
										<p>
											Last Name En:{' '}
											<strong>
												{idDoc?.lastNameEn ? idDoc?.lastNameEn : '--'}
											</strong>
										</p>
										<p>
											Id Doc Type:{' '}
											<strong>
												{idDoc?.idDocType ? idDoc?.idDocType : '--'}
											</strong>
										</p>
										<p>
											MrzLine1:{' '}
											<strong>
												{idDoc?.mrzLine1 ? idDoc?.mrzLine1 : '--'}
											</strong>
										</p>
										<p>
											MrzLine2:{' '}
											<strong>
												{idDoc?.mrzLine2 ? idDoc?.mrzLine2 : '--'}
											</strong>
										</p>
										<p>
											Number:{' '}
											<strong>{idDoc?.number ? idDoc?.number : '--'}</strong>
										</p>
										<p>
											Valid Until:{' '}
											<strong>
												{idDoc?.validUntil ? idDoc?.validUntil : '--'}
											</strong>
										</p>
										<p>
											Termless:{' '}
											<strong>{idDoc?.termless ? 'True' : 'False'}</strong>
										</p>
									</div>
								))}
						</div>
					</div>
				) : (
					<div style={{ textAlign: 'center' }}>Sum Sub data not available</div>
				)}
			</MyCard>

			{/* Modern KycAid Data Interface using Dummy Data */}
			<KycContainer style={{ marginTop: '16px' }}>
				{/* 1. Summary Block */}
				<SectionCard>
					<SummaryBlock>
						<div className="header-title">
							{data?.getUserKyc?.userId?.fullName || 'N/A'}
							<HeaderBadge status={data?.getUserKyc?.kycAidApplicantData?.verification_status === 'valid' ? 'Approved' : 'Pending'}>
								{data?.getUserKyc?.kycAidApplicantData?.verification_status === 'valid' ? 'Approved' : 'Pending'}
							</HeaderBadge>
						</div>
						
						<div className="meta-info">
							<div><span className="label">Mode: </span>Production</div>
							<div><span className="label">Verification ID: </span>{data?.getUserKyc?.userId?.kycAidData?.verification_id || 'N/A'}</div>
							<div><span className="label">Applicant ID: </span>{data?.getUserKyc?.userId?.kycAidApplicantId || '--'}</div>
							<div><span className="label">Verification created: </span>{data?.getUserKyc?.kycAidApplicantData?.created_at || '--'}</div>
							<div><span className="label">Verification processed: </span>{moment(data?.getUserKyc?.updatedAt).format('YYYY-MM-DD, HH:mm:ss')}</div>
						</div>

						<h3>Verifications</h3>
						<div className="verification-list">
							<div className="v-item">
								Profile - <HeaderBadge status={data?.getUserKyc?.kycAidVerificationData?.profile?.verified ? 'Approved' : 'Rejected'}>{data?.getUserKyc?.kycAidVerificationData?.profile?.verified ? 'Approved' : 'Rejected'}</HeaderBadge>
							</div>
							<div className="v-item">
								Document verification - <HeaderBadge status={data?.getUserKyc?.kycAidVerificationData?.document?.verified ? 'Approved' : 'Rejected'}>{data?.getUserKyc?.kycAidVerificationData?.document?.verified ? 'Approved' : 'Rejected'}</HeaderBadge>
							</div>
							<div className="v-item">
								Facial Check - <HeaderBadge status={data?.getUserKyc?.kycAidVerificationData?.facial?.verified ? 'Approved' : 'Rejected'}>{data?.getUserKyc?.kycAidVerificationData?.facial?.verified ? 'Approved' : 'Rejected'}</HeaderBadge>
							</div>
							<div className="v-item">
								Database screening - <HeaderBadge status={data?.getUserKyc?.kycAidVerificationData?.database_screening?.verified ? 'Approved' : 'Rejected'}>{data?.getUserKyc?.kycAidVerificationData?.database_screening?.verified ? 'Approved' : 'Rejected'}</HeaderBadge>
							</div>
						</div>

						<h3>Personal data</h3>
						<div className="data-list">
							<div style={{fontWeight: 600, fontSize: '16px', marginBottom: '4px'}}>General info</div>
							<div><span className="label">First name: </span>{data?.getUserKyc?.kycAidApplicantData?.first_name || '--'}</div>
							<div><span className="label">Last name: </span>{data?.getUserKyc?.kycAidApplicantData?.last_name || '--'}</div>
							<div><span className="label">Date of birth: </span>{data?.getUserKyc?.kycAidApplicantData?.dob || '--'}</div>
							<div><span className="label">Gender: </span>{data?.getUserKyc?.kycAidApplicantData?.gender || '--'}</div>
							<div><span className="label">Residence country: </span>{Country(data?.getUserKyc?.kycAidApplicantData?.residence_country?.toUpperCase()) || data?.getUserKyc?.kycAidApplicantData?.residence_country || '--'}</div>
						</div>

                        {(data?.getUserKyc?.kycAidApplicantData?.documents || [])
                            .filter((doc: any) => doc.type !== 'SELFIE_IMAGE' && doc.type !== 'LIVENESS')
                            .map((doc: any, idx: number) => (
                                <div className="data-list" key={doc.document_id || idx}>
                                    <div style={{fontWeight: 600, fontSize: '16px', marginBottom: '4px'}}>
                                        {doc.type?.replace(/_/g, ' ')?.toLowerCase()?.replace(/\b\w/g, (c: string) => c.toUpperCase()) || 'Document'}
                                    </div>
                                    <div><span className="label">Document number: </span>{doc.document_number || '--'}</div>
                                    <div><span className="label">Issue date: </span>{doc.issue_date || '--'}</div>
                                </div>
                            ))
                        }
					</SummaryBlock>
				</SectionCard>

				{/* Documents Block */}
                {(data?.getUserKyc?.kycAidApplicantData?.documents || []).map((doc: any, idx: number) => {
                    const isSelfie = doc.type === 'SELFIE_IMAGE' || doc.type === 'LIVENESS';
                    const docTitle = doc.type?.replace(/_/g, ' ')?.toLowerCase()?.replace(/\b\w/g, (c: string) => c.toUpperCase()) || 'Document';

                    return (
                        <SectionCard key={doc.document_id || idx}>
                            <h2>
                                {docTitle} 
                                <HeaderBadge status={doc.status === 'valid' ? 'Approved' : 'Pending'}>
                                    {doc.status === 'valid' ? 'Approved' : 'Pending'}
                                </HeaderBadge>
                            </h2>
                            
                            <ImageGrid>
                                {/* {doc.portrait && (
                                    <ImageCard>
                                        <div className="header">
                                            <span>Portrait</span>
                                            <a href={doc.portrait} target="_blank" rel="noreferrer">Original</a>
                                        </div>
                                        <div className="image-wrapper">
                                            <img src={doc.portrait} alt="Portrait" />
                                        </div>
                                        <div className="footer">
                                            <span>Uploaded</span>
                                            <span className="date">{moment(doc.created_at).format('YYYY-MM-DD HH:mm:ss')}</span>
                                        </div>
                                    </ImageCard>
                                )} */}
                                {/* {doc.front_side && (
                                    <ImageCard>
                                        <div className="header">
                                            <span>Front Side</span>
                                            <a href={doc.front_side} target="_blank" rel="noreferrer">Original</a>
                                        </div>
                                        <div className="image-wrapper">
                                            <img src={doc.front_side} alt="Front Side" />
                                        </div>
                                        <div className="footer">
                                            <span>Uploaded</span>
                                            <span className="date">{moment(doc.created_at).format('YYYY-MM-DD HH:mm:ss')}</span>
                                        </div>
                                    </ImageCard>
                                )} */}
                                {/* {doc.back_side && (
                                    <ImageCard>
                                        <div className="header">
                                            <span>Back side</span>
                                            <a href={doc.back_side} target="_blank" rel="noreferrer">Original</a>
                                        </div>
                                        <div className="image-wrapper">
                                            <img src={doc.back_side} alt="Back Side" />
                                        </div>
                                        <div className="footer">
                                            <span>Uploaded</span>
                                            <span className="date">{moment(doc.created_at).format('YYYY-MM-DD HH:mm:ss')}</span>
                                        </div>
                                    </ImageCard>
                                )} */}
                                {/* {doc.other_side_1 && (
                                    <ImageCard>
                                        <div className="header">
                                            <span>Other side 1</span>
                                            <a href={doc.other_side_1} target="_blank" rel="noreferrer">Original</a>
                                        </div>
                                        <div className="image-wrapper">
                                            <img src={doc.other_side_1} alt="Other Side 1" />
                                        </div>
                                        <div className="footer">
                                            <span>Uploaded</span>
                                            <span className="date">{moment(doc.created_at).format('YYYY-MM-DD HH:mm:ss')}</span>
                                        </div>
                                    </ImageCard>
                                )} */}
                                {/* {doc.other_side_2 && (
                                    <ImageCard>
                                        <div className="header">
                                            <span>Other side 2</span>
                                            <a href={doc.other_side_2} target="_blank" rel="noreferrer">Original</a>
                                        </div>
                                        <div className="image-wrapper">
                                            <img src={doc.other_side_2} alt="Other Side 2" />
                                        </div>
                                        <div className="footer">
                                            <span>Uploaded</span>
                                            <span className="date">{moment(doc.created_at).format('YYYY-MM-DD HH:mm:ss')}</span>
                                        </div>
                                    </ImageCard>
                                )} */}
                                {/* {doc.other_side_3 && (
                                    <ImageCard>
                                        <div className="header">
                                            <span>Other side 3</span>
                                            <a href={doc.other_side_3} target="_blank" rel="noreferrer">Original</a>
                                        </div>
                                        <div className="image-wrapper">
                                            <img src={doc.other_side_3} alt="Other Side 3" />
                                        </div>
                                        <div className="footer">
                                            <span>Uploaded</span>
                                            <span className="date">{moment(doc.created_at).format('YYYY-MM-DD HH:mm:ss')}</span>
                                        </div>
                                    </ImageCard>
                                )} */}
                            </ImageGrid>

                            {!isSelfie && (
                                <DataBlock>
                                    <h3>Document data</h3>
                                    <div className="grid">
                                        <div className="field">
                                            <div className="label">Document number</div>
                                            <div className="value">{doc.document_number || '-'}</div>
                                        </div>
                                        <div className="field">
                                            <div className="label">Additional number</div>
                                            <div className="value">{doc.additional_number || '-'}</div>
                                        </div>
                                        <div className="field">
                                            <div className="label">Issuing authority</div>
                                            <div className="value">{doc.issuing_authority || '-'}</div>
                                        </div>
                                        <div className="field">
                                            <div className="label">Issue date</div>
                                            <div className="value">{doc.issue_date || '-'}</div>
                                        </div>
                                        <div className="field">
                                            <div className="label">Expiry date</div>
                                            <div className="value">{doc.expiry_date || '-'}</div>
                                        </div>
                                    </div>
                                </DataBlock>
                            )}
                        </SectionCard>
                    );
                })}

			</KycContainer>

			<Divider />

			<MyTableCard>
				<TableHeaderSection
					tableName="Rejected KYC History"
					currentPage={kycHistory?.paginator?.currentPage || 0}
					totalRecords={kycHistory?.paginator?.itemCount || 0}
				/>
				<MyTable
					locale={{
						emptyText: <MyEmptyTable />,
					}}
					loading={kycHistory?.loading || false}
					columns={columns2}
					dataSource={kycHistory.itemsList}
					pagination={false}
				/>
			</MyTableCard>
		</div>
	);
};

export default ManageKYC;
